<template>
  <div class="product-card">
    <div class="image-frame"><img :src="data.image+'?$Mini$'"></div>
    <div class="discount" :class="{'extra':showDiscount == 'IMPERDIBLE'}" v-show="showDiscount">{{ showDiscount }}</div>
    <h3 class="title">{{ data.title }}</h3>
    <p class="description">{{data.description}}</p>
    <div class="price-box" v-if="data.price != 0">
      <p class="price" v-show="data.price && data.price != data.sale">${{ data.price }}</p>
      <p class="sale">${{ data.sale }}</p>
    </div>
    <a href="#" @click="viewDetailsProduct" class="go-btn">Ver +</a>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: 'Product',
  props: {
    data: Object,
    category: String,
    indice: Number,
    origin: String
  },
  computed: {
    showDiscount () {
      if (this.data.discount) {
        console.log(this.data.discount)
        let discount = this.data.discount.toLowerCase()
        switch (this.data.discount) {
          case 'superprecio':
            discount = 'SUPER\nPRECIO'
            break
          case 'IMPERDIBLE':
            discount = 'IMPERDIBLE'
            break;
          case '4x3':
          case '2x1':
          case '6x4':
          case '3x2':
            break
          default:
            discount = discount + '%'
            break
        }
        return discount
      } else {
        return null
      }
    }
  },
  methods: {
    viewDetailsProduct (ev) {
      ev.preventDefault()
      ev.stopPropagation()
      console.log(this.origin)
      let productData = this.origin == 'top' ? this.$parent.$parent.productsData[this.data.sku] : this.$parent.$parent.$parent.productsData[this.data.sku]
      dataLayer.push({
          'event': 'promotionClick',
          'ecommerce': {
            'promoClick': {
              'promotions': [
              {
                'id': 'product-card',
                'name': `${productData.sku}/${productData.title}`,                     // Nombre de la imagen
                'creative': this.data.image,             // URL de la imagen
                'position': this.category+'/module '+this.indice               // Nombre de la sección + la posición
              }]
            }
          }
      });
      if(this.origin == 'top'){
        this.$parent.$parent.openDetail(this.data.sku)
      }else{
        this.$parent.$parent.$parent.openDetail(this.data.sku)
      }
    }
  },
  data () {
    return {
      test: 'Test'
    }
  }
}
</script>
<style scoped>
  .item-list {height: 335px;}
  .product-card {height: 335px;position: relative;}
  .item-container,.image-frame { width: 100%; }
  .image-frame { width: 100%;border:solid thin #ebebeb; }
  .image-frame img{ width: 75%; }
  .title { font-family: 'Montserrat', sans-serif;font-size: 1.150em;line-height: 1.150em;text-align: left;font-weight: 600;margin-bottom: 0px;max-height: 65px;margin-top: 10px;overflow: hidden;}
  .description{font-family: 'Montserrat', sans-serif;font-size:0.850em;color:#666;margin:0px;text-align:left}
  .discount { font-family: 'Montserrat', sans-serif;width:40px;height:40px;background-color:#ed1b23;line-height:42px;color:#feeb00;border-radius:20px;position:absolute;top:5px;left:5px;font-weight:800 }
  .discount.extra{font-size:12px;color:#fff;width:100px;}
  .price-box{font-family: 'Montserrat', sans-serif;position:absolute;bottom:30px;}
  .price,.sale { margin:0px;text-align:left }
  .price { font-family: 'Montserrat', sans-serif;text-decoration:line-through;color:#000;font-size:1em;letter-spacing:1px; }
  .sale { font-family: 'Montserrat', sans-serif;font-weight: 600;color:#E0172F;font-size:1.500em;letter-spacing:1px;margin-bottom:10px; }
  .go-btn { color: #fff;background-color: #E0172F;display: block;width: 100%;margin: 5px auto;padding: 3px 0px;text-decoration: none;border-radius:5px;position:absolute;bottom:0px; }
  @media only screen and (min-width: 1000px) {
    .item-list {height:45vh;vertical-align: top;}
    .product-card {height:45vh;position:relative;}
    .title{font-size: 0.850em;line-height: 16px;padding-bottom: 0px;font-weight: 600;margin-bottom:0px}
    .image-frame { width:200px;border:solid thin #ebebeb; }
    .image-frame img {width: auto;max-height: 19vh;}
    .price {font-size:14px; color:#666}
    .sale { font-weight: 600;color:#E0172F;font-size:18px;margin-bottom:15px}
  }
  @media only screen and (min-width: 1400px) {
    .title{font-size: 18px;line-height: 20px;padding-bottom: 15px;font-weight: 400;}
    .price {font-size:14px; color:#666}
    .sale { font-weight: 600;color:#E0172F;font-size:18px;margin-bottom:15px}
  }
</style>



// WEBPACK FOOTER //
// src/components/ProductComponent.vue